var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPmgProject({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 11.2,
    fill: "#D9D6FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8332 15.8369V21.0001C30.8332 21.7002 30.8332 22.0502 30.9876 22.3176C31.1234 22.5528 31.3401 22.744 31.6067 22.8638C31.9097 23.0001 32.3064 23.0001 33.0998 23.0001H38.9514M33.6665 29.25H22.3332M33.6665 34.25H22.3332M25.1665 24.25H22.3332M30.8332 15.5H23.4665C21.0863 15.5 19.8962 15.5 18.987 15.9087C18.1874 16.2683 17.5372 16.8419 17.1297 17.5475C16.6665 18.3497 16.6665 19.3998 16.6665 21.5V34.5C16.6665 36.6002 16.6665 37.6503 17.1297 38.4525C17.5372 39.1581 18.1874 39.7317 18.987 40.0913C19.8962 40.5 21.0863 40.5 23.4665 40.5H32.5332C34.9134 40.5 36.1035 40.5 37.0126 40.0913C37.8123 39.7317 38.4625 39.1581 38.8699 38.4525C39.3332 37.6503 39.3332 36.6002 39.3332 34.5V23L30.8332 15.5Z",
    stroke: "#6941C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmgProject);
export default __webpack_public_path__ + "static/media/pmg-project.3c25bbfe7fd87bfd8f48d940775a5473.svg";
export { ForwardRef as ReactComponent };